import { getSpacing } from './space.esm.js';
import { system } from './system-core.esm.js';

// port from @styled-system/space v.5.1.2
var defaults = {
  space: [0, 4, 8, 16, 32, 64, 128, 256, 512]
};
var config = {
  position: true,
  zIndex: {
    property: 'zIndex',
    scale: 'zIndices'
  },
  top: {
    property: 'top',
    scale: 'space',
    transform: getSpacing,
    defaultScale: defaults.space
  },
  right: {
    property: 'right',
    scale: 'space',
    transform: getSpacing,
    defaultScale: defaults.space
  },
  bottom: {
    property: 'bottom',
    scale: 'space',
    transform: getSpacing,
    defaultScale: defaults.space
  },
  left: {
    property: 'left',
    scale: 'space',
    transform: getSpacing,
    defaultScale: defaults.space
  }
};
var position = system(config);

export default position;
export { position };
//# sourceMappingURL=position.esm.js.map
